import { useState, type ReactNode } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { logout } from "../api/client";

const sections = [
  { to: "/advertisers", label: "Рекламодатели" },
  { to: "/placements", label: "Плейсменты" },
  { to: "/campaigns", label: "Кампании" },
  { to: "/creatives", label: "Креативы" },
  { to: "/statistics", label: "Статистика" },
  { to: "/integration-credentials", label: "S2S-ключи" },
];

export function Shell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [logoutError, setLogoutError] = useState<string | null>(null);
  const [loggingOut, setLoggingOut] = useState(false);

  async function handleLogout() {
    setLoggingOut(true);
    setLogoutError(null);
    try {
      await logout();
      queryClient.clear();
      navigate("/login", { replace: true });
    } catch {
      setLogoutError("Не удалось завершить сессию. Повторите выход.");
    } finally {
      setLoggingOut(false);
    }
  }

  return (
    <div className="shell">
      <aside className="sidebar">
        <h1>Alot Content</h1>
        <nav className="nav">
          {sections.map((s) => (
            <NavLink key={s.to} to={s.to} className={({ isActive }) => (isActive ? "active" : "")}>
              {s.label}
            </NavLink>
          ))}
        </nav>
        <hr style={{ margin: "16px 0", border: 0, borderTop: "1px solid var(--border)" }} />
        <button type="button" onClick={() => void handleLogout()} disabled={loggingOut}>
          {loggingOut ? "Выхожу…" : "Выйти"}
        </button>
        {logoutError && <p className="error" role="alert">{logoutError}</p>}
      </aside>
      <main className="content">{children}</main>
    </div>
  );
}
